var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2325 10.5001C19.2325 15.3229 15.3228 19.2326 10.5 19.2326C5.67719 19.2326 1.76752 15.3229 1.76752 10.5001C1.76752 5.67725 5.67719 1.76758 10.5 1.76758C15.3228 1.76758 19.2325 5.67725 19.2325 10.5001ZM11.13 6.67195C11.13 7.14071 10.75 7.5207 10.2813 7.5207C9.81252 7.5207 9.43252 7.14071 9.43252 6.67195C9.43252 6.2032 9.81252 5.8232 10.2813 5.8232C10.75 5.8232 11.13 6.2032 11.13 6.67195ZM9.87002 13.8076V9.81758H9.62502C9.27708 9.81758 8.99502 9.53552 8.99502 9.18758C8.99502 8.83964 9.27708 8.55758 9.62502 8.55758H10.5C10.848 8.55758 11.13 8.83964 11.13 9.18758V13.8076H11.375C11.723 13.8076 12.005 14.0896 12.005 14.4376C12.005 14.7855 11.723 15.0676 11.375 15.0676H9.62502C9.27708 15.0676 8.99502 14.7855 8.99502 14.4376C8.99502 14.0896 9.27708 13.8076 9.62502 13.8076H9.87002Z",
    fill: "#08081B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_958_1024",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 19,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2325 10.5001C19.2325 15.3229 15.3228 19.2326 10.5 19.2326C5.67719 19.2326 1.76752 15.3229 1.76752 10.5001C1.76752 5.67725 5.67719 1.76758 10.5 1.76758C15.3228 1.76758 19.2325 5.67725 19.2325 10.5001ZM11.13 6.67195C11.13 7.14071 10.75 7.5207 10.2813 7.5207C9.81252 7.5207 9.43252 7.14071 9.43252 6.67195C9.43252 6.2032 9.81252 5.8232 10.2813 5.8232C10.75 5.8232 11.13 6.2032 11.13 6.67195ZM9.87002 13.8076V9.81758H9.62502C9.27708 9.81758 8.99502 9.53552 8.99502 9.18758C8.99502 8.83964 9.27708 8.55758 9.62502 8.55758H10.5C10.848 8.55758 11.13 8.83964 11.13 9.18758V13.8076H11.375C11.723 13.8076 12.005 14.0896 12.005 14.4376C12.005 14.7855 11.723 15.0676 11.375 15.0676H9.62502C9.27708 15.0676 8.99502 14.7855 8.99502 14.4376C8.99502 14.0896 9.27708 13.8076 9.62502 13.8076H9.87002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_958_1024)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFilled);
export default __webpack_public_path__ + "static/media/Info-filled.67af249e17081289b1a0c5959a04f700.svg";
export { ForwardRef as ReactComponent };